import { Component, Input } from '@angular/core';

@Component({
   selector: 'samweb-highlight-text',
   templateUrl: './highlight-text.component.html',
   styleUrls: ['./highlight-text.component.scss'],
})
export class HighlightTextComponent {
   @Input()
   public searchValue: string[];
   @Input()
   public primaryText: string;
   @Input()
   public secondaryText?: string;
   @Input()
   public isCallable?: boolean;

   constructor() {}
}
